import { Component, computed, inject, Input, ViewChild } from '@angular/core';
import { NotificationService } from '../../services/notifications.service';
import { Router } from '@angular/router';
import { NgbDropdown, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NotificationsComponent } from '../notifications.component';

@Component({
    selector: 'app-notification-bill',
    standalone: true,
    imports: [NgbDropdownModule, NotificationsComponent],
    templateUrl: './notification-bill.component.html',
    styleUrls: ['./notification-bill.component.scss'],
    animations: []
})
export class NotificationBillComponent {
    @Input() notificationsLimit: number = 5;

    router = inject(Router);
    notificationService = inject(NotificationService);
    notificationsCount = computed(() => this.notificationService.unreadCount());
    @ViewChild('notificationRef', { static: true }) notificationRef?: NgbDropdown;

    isOnNotificationsPage(): boolean {
        return this.router.url.includes('notifications');
    }

    seeAllNotification(): void {
        if (this.notificationRef) {
            this.notificationRef.close();
        }
        this.router.navigate(['notifications']);
    }

    ShowSeeAllNotification(): boolean {
        return this.notificationService.getAllNotifications().length > this.notificationsLimit;
    }

}
